<template>
  <div class="main-filter__fixed-panel  d-none  d-sm-flex">
    <div class="main-filter__fixed-panel-text">{{ $tFilter('Found vacancies') }} {{ quantity }}</div>
    <button @click.prevent="onClick"
            class="main-filter__fixed-panel-btn  base-btn  base-btn--green  base-btn--small">
      {{ $tFilter('Show') }}
    </button>
  </div>
</template>

<script>
  export default {
    name: 'MainFilterFixedPanel',
    data() {
      return {}
    },
    computed: {
      quantity() {
        return this.$store.state.vacancies.total || 0
      }
    },
    methods: {
      onClick() {
        this.$vModal.close('main-filter-mobile')

        this.$scrollTo('#vacancies-list')
      }
    }
  }
</script>

<style lang="less">

</style>